import { render, staticRenderFns } from "./reconciliation.vue?vue&type=template&id=20606480&scoped=true"
import script from "./reconciliation.vue?vue&type=script&lang=js"
export * from "./reconciliation.vue?vue&type=script&lang=js"
import style0 from "./reconciliation.vue?vue&type=style&index=0&id=20606480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20606480",
  null
  
)

export default component.exports